import { app as routes } from '../../routes.json';
import { ErrorStateType } from '../../types/errors';

export const defaultRoute = (): string => routes.documentation;

export const acceptShowTermsOfService = (errors: ErrorStateType[]): boolean => {
  return errors.includes(ErrorStateType.InvalidTOS);
};
